import Button, { Theme } from "theme/components/buttons/Button";

import React from "react";
import colors from "theme/config/colors";

const BlueSolidButton = (props: any) => {
    const theme: Theme = {
        color: colors.white,
        backgroundColor: colors.blue_900,
        borderColor: colors.blue_900,
        hover: {
            backgroundColor: colors.neutral_700,
            borderColor: colors.neutral_700,
        },
        active: {
            backgroundColor: colors.neutral_700,
            borderColor: colors.neutral_700,
        },
        selected: {
            backgroundColor: colors.blue_700,
            borderColor: colors.blue_700,
        },
        disabled: {
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default BlueSolidButton;
